import { cAdminAdsItem } from "./admin-ads-item";

export class cAdminAds {

  button_save  = document.createElement('button');
  span_spinner = document.createElement('span');
  div_item     = document.querySelector('.c-admin-ads')          as HTMLElement;
  script       = document.querySelector('.c-admin-ads > script') as HTMLScriptElement;

  itemElms  : cAdminAdsItem[] = [];
  inputData : AdsData;

  constructor() {

    this.inputData = JSON.parse(this.script.innerText);

    // ---- structure ----
    for(const item of this.inputData.items) {
      this.itemElms.push(new cAdminAdsItem(this.div_item, item));
    }
    this.div_item.append(this.button_save);
      this.button_save.append(this.span_spinner);

    // ---- Texts ----
    this.span_spinner.before('Liste Speichern');

    // ---- Ohter ----
    this.button_save.type = 'button';

    // ---- Events ----
    this.button_save.addEventListener('click', async () => {

      this.inputData.items = [];
      for(const item of this.itemElms) {
        this.inputData.items.push(item.getData());
      }      
      const dataString = JSON.stringify(this.inputData);
      this.span_spinner.classList.add('c-spinner');
      const result = await this.fetch(dataString, 'c_ads_save');
      this.span_spinner.classList.remove('c-spinner');
      Toastify({
        text      : result,
        className : 'c-success', 
        offset    : {x: 0, y: '20px'},
        close     : true,
      }).showToast();
    });
  }

  async fetch(data: string, action: string): Promise<string> {
    const  formData = new FormData();
    formData.append('_ajax_nonce', this.inputData.nonce);
    formData.append('action'     , action);
    formData.append('data'       , data);
  
    const response = await fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      body: formData
    });
    const responseData = await response.json() as string;
    return responseData;
  }
  
}